import { render, staticRenderFns } from "./ldTabbar.vue?vue&type=template&id=0647df3e&scoped=true&"
import script from "./ldTabbar.vue?vue&type=script&lang=js&"
export * from "./ldTabbar.vue?vue&type=script&lang=js&"
import style0 from "./ldTabbar.vue?vue&type=style&index=0&id=0647df3e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0647df3e",
  null
  
)

export default component.exports